/* 图片后处理 —— 去底 / 滤镜 / 混合模式（2026-09-13，第 0+3+4+5 批）
   刻意外置在 assets/ —— sections/design-canvas.liquid 逼近 Shopify 256KB 模板上限，只留桥接。

   ⚠️ 三个实测得来的坑（写死在这里，别改）：
   ① fabric 5.3 的 img.applyFilters() **必须无参调用**。传回调会让它把函数当滤镜数组 →
      `t.filter is not a function`，且异常被静默吞掉（源码：applyFilters(filters) 第一参数是数组）。
   ② 滤镜对象进 toJSON / loadFromJSON，参数一并保留 → undo/redo 天然可用，无需自定义字段。
   ③ isNeutralState() 会自动丢弃"归零"的滤镜（Brightness/Contrast 0、Blur 0、Hue 0、Pixelate 1），
      所以滑杆归零 = 等于没加，不会残留 —— 但仍要在数组里按固定序重建，避免顺序漂移导致画面变化。

   依赖（由 section 的 hdImageBridge 注入）：canvas / render / save / toast / refresh

   ⚠️ 2026-09-13 改：面板从「画布上的浮层」改成「属性面板内嵌一块」。
      原因是浮层会挡住正在调整的图案（用户反馈）—— 这是「边调边看」的面板，必须避开画布。
      内嵌后不再需要 reposition / 跟随定时器 / 外部点击关闭，也不再进 canvas 的 KEEP 白名单
      （它已在 .pfm-props 内，containment 自动覆盖）。
*/
(function () {
  'use strict';
  var q = function (id) { return document.getElementById(id); };
  var D = {}, inited = false, built = false, openFlag = false;
  var cur = null;   /* { img, parent } 当前目标 */
  var ST = null;    /* 面板状态（滑杆值的唯一真源） */

  /* 有序滤镜登记：数组顺序 = applyFilters 生效顺序（去底 → 色彩 → 质感） */
  var ADJ = [
    { k: 'brightness', lbl: 'Bright', min: -100, max: 100, step: 1, def: 0, ctor: 'Brightness', param: 'brightness', toF: function (v) { return v / 100; }, fromF: function (v) { return Math.round(v * 100); } },
    { k: 'contrast', lbl: 'Contrast', min: -100, max: 100, step: 1, def: 0, ctor: 'Contrast', param: 'contrast', toF: function (v) { return v / 100; }, fromF: function (v) { return Math.round(v * 100); } },
    { k: 'saturation', lbl: 'Sat', min: -100, max: 100, step: 1, def: 0, cm: 'sat' },
    { k: 'hue', lbl: 'Hue', min: -180, max: 180, step: 1, def: 0, ctor: 'HueRotation', param: 'rotation', toF: function (v) { return v * Math.PI / 180; }, fromF: function (v) { return Math.round(v * 180 / Math.PI); } },
    { k: 'blur', lbl: 'Blur', min: 0, max: 100, step: 1, def: 0, ctor: 'Blur', param: 'blur', toF: function (v) { return v / 100; }, fromF: function (v) { return Math.round(v * 100); } },
    { k: 'pixelate', lbl: 'Pixel', min: 1, max: 40, step: 1, def: 1, ctor: 'Pixelate', param: 'blocksize', toF: function (v) { return v; }, fromF: function (v) { return Math.round(v); } }
  ];
  var TOGGLES = [['grayscale', 'Gray'], ['sepia', 'Sepia'], ['invert', 'Invert'], ['blackwhite', 'B&W']];
  var CTOR = { grayscale: 'Grayscale', sepia: 'Sepia', invert: 'Invert', blackwhite: 'BlackWhite' };
  var BLENDS = [['source-over', 'Normal'], ['multiply', 'Multiply'], ['screen', 'Screen'], ['overlay', 'Overlay'],
    ['darken', 'Darken'], ['lighten', 'Lighten'], ['difference', 'Diff'], ['soft-light', 'Soft light']];
  /* 2026-09-13: 裁切四边（百分比，相对原图）。crop 不是滤镜 —— 直接改对象的
     cropX/cropY/width/height，与 filters[] 并行、互不影响。 */
  var CROP = [['l', 'Left'], ['r', 'Right'], ['t', 'Top'], ['b', 'Bottom']];

  /* 2026-09-16: 位图着色（Colorize）—— 唯一能给「位图」改色的入口。
     实测（探针 probe_blendcolor.js）：tint α=1 把不透明像素整体换成该色且保留 alpha；
     multiply 给亮部上色（黑保留）；screen 给暗部上色（白保留）。
     overlay 结果错乱、**diffuse 在 fabric 5.3 WebGL 下着色器编译报错**（实测）⇒ 均不暴露。
     滤镜顺序见 commit()：**必须早于饱和度/调整**，否则 tint 会把调整结果压平、滑杆像没反应。 */
  var CZ_MODES = [['tint', 'Recolor'], ['multiply', 'Tint light'], ['screen', 'Tint dark']];
  var CZ_DEF = { color: '#7C3AED', amount: 100, mode: 'tint' };

  /* 饱和度专用：fabric 5.3 自带的 `Saturation` 在真机画布上把饱和色「去」成纯白
     （纯红 #f00 + saturation:-1 → [255,255,255]，实测确认，不是采样问题），
     去饱和方向错成"往白"而不是"往灰"。→ 改用 ColorMatrix + 自算亮度矩阵：
     真机验证 纯红 → [54,54,54]（= 精确亮度灰），且 ColorMatrix 的 WebGL 与 2D 两条路径
     读的是同一份 matrix，行为确定。矩阵第 0 项 = (1-s)·0.2126 + s → s 可精确反解，
     所以滑杆值不必另存自定义字段就能还原。
     （注：`HueRotation` 真机是好的 —— 只有 `applyTo2d` 那条 2D 回退路径不生效，故保留原生。） */
  var SAT_LR = 0.2126, SAT_LG = 0.7152, SAT_LB = 0.0722;
  function satMatrix(s) {
    var i = 1 - s;
    return [i * SAT_LR + s, i * SAT_LG, i * SAT_LB, 0, 0,
            i * SAT_LR, i * SAT_LG + s, i * SAT_LB, 0, 0,
            i * SAT_LR, i * SAT_LG, i * SAT_LB + s, 0, 0,
            0, 0, 0, 1, 0];
  }

  function cv() { return D.canvas ? D.canvas() : null; }
  function render() { if (D.render) { try { D.render(); } catch (e) { } } }
  function save() { if (D.save) { try { D.save(); } catch (e) { } } }
  function toast(m) { if (D.toast) { try { D.toast(m); } catch (e) { } } }
  /* 2026-09-19: 图片动作「无效时」的说明 —— 不弹 toast，改在抽屉内显示（用户要求）。
     挂在 #pfmImgHint（抽屉滚动体第一块），9s 自动收起；换选中 / 打开 Effects 面板立即收起。 */
  function hint(m) {
    var el = q('pfmImgHint');
    if (!el) { toast(m); return; }
    el.textContent = m; el.style.display = 'block';
    /* 2026-09-19: **不自动消除**（用户要求）。它会一直留到：① 换选中对象 ② 抠底成功
       ③ 被下一条说明替换。原先的 9s 定时器已删。 */
  }
  function syncOpacity() {
    var opb = q('pfmImgOpacity'); if (!opb) return;
    var o = null; try { var c2 = cv(); o = c2 && c2.getActiveObject ? c2.getActiveObject() : null; } catch (e) { }
    var v = Math.round((o && o.opacity !== undefined ? o.opacity : 1) * 100);
    opb.value = String(v);
    var vv = q('pfmImgOpacityVal'); if (vv) vv.textContent = v;
  }
  function clearHint() {
    var el = q('pfmImgHint');
    if (el) el.style.display = 'none';
  }
  /* 2026-09-19: 说明条**只属于「BG 抽屉」**（用户要求）—— 离开 BG 上下文就收起：
     切到别的格 / 换对象 / 取消选中 / 抽屉收起。判定 = BG 格高亮，或动作锁正锁在 BG 格
     （点 BG 后 section 会 setActive 到那一格并挂 __pfmObjAct；切别的格时锁被清空）。 */
  function bgContext() {
    try {
      var act = window.__pfmObjAct;
      if (act && act.btn && act.btn.getAttribute('data-objtab') === 'bg') return true;
      var sel = document.querySelector('#pfmTabObj .pfm-stab.sel');
      return !!(sel && sel.getAttribute('data-objtab') === 'bg' && sel.getAttribute('data-off') !== '1');
    } catch (e) { return false; }
  }
  function watchHint() {
    var box = q('pfmTabObj'), pr = q('pfmProps'), i;
    function check() { if (!bgContext()) clearHint(); }
    if (box && window.MutationObserver && !box.__pfmHintW) {
      box.__pfmHintW = true;
      try { new MutationObserver(function () { setTimeout(check, 0); }).observe(box, { attributes: true, subtree: true, attributeFilter: ['class'] }); } catch (e) { }
    }
    if (pr && window.MutationObserver && !pr.__pfmHintW) {
      pr.__pfmHintW = true;
      try { new MutationObserver(function () {
        if (!pr.classList.contains('pfm-open')) {
          clearHint();
          /* 2026-09-19: 抽屉收起 ⇒ 效果面板的「打开态」作废（它就在抽屉里，已经看不见了）。
             不关掉的话，下次点 Effects 格会被当成「再点一次收起」⇒ 抽屉打开却是空白。 */
          if (window.__pfmTouchLayout && window.__pfmTouchLayout()) close();
        }
      }).observe(pr, { attributes: true, attributeFilter: ['class'] }); } catch (e) { }
    }
    var c = cv();
    if (c && c.on && !c.__pfmHintW) {
      c.__pfmHintW = true;
      ['selection:created', 'selection:updated', 'selection:cleared'].forEach(function (ev) { c.on(ev, function () { setTimeout(check, 0); }); });
    }
    check();
  }

  /* ---------- 目标解析：图片本体 / 组内图片下钻（成组后必须下钻，否则加不上滤镜） ---------- */
  function resolveTarget() {
    var c = cv(); if (!c) return null;
    var o = null;
    try { o = c.getActiveObject(); } catch (e) { return null; }
    if (!o || o.isGrid) return null;
    if (o.type === 'image') return { img: o, parent: null };
    if (o.type === 'group' || (o.getObjects && o.type === 'activeSelection')) {
      var kids = o.getObjects() || [];
      for (var i = 0; i < kids.length; i++) {
        if (kids[i] && kids[i].type === 'image') return { img: kids[i], parent: o };
      }
    }
    return null;
  }

  /* ---------- 裁切：辅助 ---------- */
  /* 原图尺寸锚点 —— `_originalElement` 是未被裁切的原始图，序列化往返后仍完整
     （probe 实测），所以滑杆值可以无误差地反解。不用新增自定义字段。 */
  function oW(img) { return (img._originalElement && img._originalElement.width) || img.width || 1; }
  function oH(img) { return (img._originalElement && img._originalElement.height) || img.height || 1; }
  function clampPct(v) { v = parseInt(v, 10); if (!isFinite(v)) v = 0; return Math.max(0, Math.min(49, v)); }
  function clampCrop(st) {
    st.cropL = clampPct(st.cropL); st.cropR = clampPct(st.cropR);
    st.cropT = clampPct(st.cropT); st.cropB = clampPct(st.cropB);
    if (st.cropL + st.cropR > 98) st.cropR = Math.max(0, 98 - st.cropL);
    if (st.cropT + st.cropB > 98) st.cropB = Math.max(0, 98 - st.cropT);
  }
  /* 应用裁切。位置补偿：fabric 默认钉住图左上角 -> 裁左边会让内容整体左移；
     按 cropX 的**增量**调 left，让剩余内容留在原位（视觉等同 Photoshop）。
     增量自洽 —— 重复 commit 不会叠加补偿，undo 也能正确回退。 */
  function applyCrop(img) {
    if (!ST) return;
    clampCrop(ST);
    var W0 = oW(img), H0 = oH(img);
    var L = ST.cropL, R = ST.cropR, T = ST.cropT, B = ST.cropB;
    var cx = Math.round(L / 100 * W0), cy = Math.round(T / 100 * H0);
    var nw = Math.max(1, W0 - cx - Math.round(R / 100 * W0));
    var nh = Math.max(1, H0 - cy - Math.round(B / 100 * H0));
    var dX = cx - (img.cropX || 0), dY = cy - (img.cropY || 0);
    if (dX) img.left = (img.left || 0) + dX * (img.scaleX || 1);
    if (dY) img.top = (img.top || 0) + dY * (img.scaleY || 1);
    img.set({ cropX: cx, cropY: cy, width: nw, height: nh });
    try { img.setCoords(); } catch (e) { }
  }
  function syncCropUI() {
    CROP.forEach(function (c) {
      var r = q('pfmImgCrop_' + c[0]), v = q('pfmImgCropVal_' + c[0]);
      var k = 'crop' + c[0].toUpperCase();
      var val = ST ? (ST[k] || 0) : 0;
      if (r) r.value = val;
      if (v) v.textContent = val + '%';
    });
  }

  /* ---------- 读状态：从 object.filters 反推滑杆值 ---------- */
  function snap(img) {
    var st = { rm: null, cz: null, grayscale: false, sepia: false, invert: false, blackwhite: false,
      cropL: 0, cropR: 0, cropT: 0, cropB: 0 };
    ADJ.forEach(function (a) { st[a.k] = a.def; });
    var fs = img.filters || [];
    for (var i = 0; i < fs.length; i++) {
      var f = fs[i], t = f.type;
      if (t === 'RemoveColor') { st.rm = { color: f.color, distance: (typeof f.distance === 'number' ? f.distance : 0.12) }; continue; }
      /* 边缘感知去底：参数无法从蒙版反推 -> 读回挂在对象上的 __pfmBgCut（已进序列化白名单） */
      if (t === 'BlendImage') {
        var bc = img.__pfmBgCut;
        st.rm = bc ? { color: bc.color || '#ffffff', distance: (typeof bc.tol === 'number' ? bc.tol : 0.12) }
                  : { color: '#ffffff', distance: 0.12 };
        continue;
      }
      if (CTOR.grayscale === t) { st.grayscale = true; continue; }
      if (CTOR.sepia === t) { st.sepia = true; continue; }
      if (CTOR.invert === t) { st.invert = true; continue; }
      if (CTOR.blackwhite === t) { st.blackwhite = true; continue; }
      /* 着色（BlendColor）—— color/mode/alpha 都由 fabric 原生序列化，无需自定义字段 */
      if (t === 'BlendColor') {
        st.cz = { color: f.color || CZ_DEF.color,
                  amount: Math.round((typeof f.alpha === 'number' ? f.alpha : 1) * 100),
                  mode: (typeof f.mode === 'string' && f.mode) ? f.mode : 'tint' };
        continue;
      }
      /* ColorMatrix = 饱和度（唯一用途）→ 从矩阵第 0 项反解滑杆值 */
      if (t === 'ColorMatrix') {
        if (f.matrix && f.matrix.length === 20 && isFinite(f.matrix[0])) {
          var sp = (f.matrix[0] - SAT_LR) / (1 - SAT_LR);
          if (isFinite(sp)) st.saturation = Math.max(-100, Math.min(100, Math.round((sp - 1) * 100)));
        }
        continue;
      }
      for (var j = 0; j < ADJ.length; j++) {
        if (ADJ[j].ctor === t) { st[ADJ[j].k] = ADJ[j].fromF(f[ADJ[j].param]); break; }
      }
    }
    /* 裁切（相对原图百分比；_originalElement 为原图锚点） */
    var W0 = oW(img), H0 = oH(img);
    var cX = img.cropX || 0, cY = img.cropY || 0;
    st.cropL = Math.round(cX / W0 * 100);
    st.cropT = Math.round(cY / H0 * 100);
    st.cropR = Math.round((W0 - cX - img.width) / W0 * 100);
    st.cropB = Math.round((H0 - cY - img.height) / H0 * 100);
    clampCrop(st);
    return st;
  }

  /* ---------- 像素安全探测：跨域图（创作者市场 design_url）会被污染，滤镜无法工作 ---------- */
  function pixelSafe(img) {
    if (img.__pfmFxSafe !== undefined) return img.__pfmFxSafe;
    var ok = true;
    try {
      var el = img._originalElement || img._element;
      var c = document.createElement('canvas'); c.width = 1; c.height = 1;
      var g = c.getContext('2d');
      g.drawImage(el, 0, 0, 1, 1);
      g.getImageData(0, 0, 1, 1);
    } catch (e) { ok = false; }
    img.__pfmFxSafe = ok;
    return ok;
  }

  /* ---------- 边缘感知去底（2026-09-13）----------
     与 RemoveColor 的本质区别：RemoveColor **全图按色删** -> 会误删主体内部的同色区域
     （白底图里的白衬衫 / 白 logo 被整块掏空）；泛洪只从**四角**蔓延，主体内部同色不受影响。
     flood-fill 是迭代算法、写不成单遍 shader -> 只让它产出**蒙版**，合成交给内置
     `BlendImage(mode:'mask')`（shader 由 fabric 提供，实测可序列化 + 往返正常）。 */
  function hex2rgb(h) {
    h = String(h || '#ffffff').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    if (!isFinite(n)) return [255, 255, 255];
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function oEl(img) { return img._originalElement || img._element; }
  /* 返回蒙版 canvas：外部（与边缘连通且色近底色）alpha=0，其余 alpha=255（白色保留）。
     降采样到 <=512：蒙版精度足够，BlendImage 线性插值反而自带边缘羽化，体积也从 MB 降到 KB。 */
  function floodMask(el, color, tol) {
    try {
      var W0 = el.naturalWidth || el.width, H0 = el.naturalHeight || el.height;
      if (!W0 || !H0) return null;
      var mw = Math.min(512, W0), mh = Math.max(1, Math.round(H0 * mw / W0));
      var sc = document.createElement('canvas'); sc.width = mw; sc.height = mh;
      var sg = sc.getContext('2d', { willReadFrequently: true });
      sg.drawImage(el, 0, 0, mw, mh);
      var idata = sg.getImageData(0, 0, mw, mh), d = idata.data;
      var tc = hex2rgb(color);
      var lim = Math.max(1, (typeof tol === 'number' ? tol : 0.12) * 255);
      var lim2 = lim * lim * 3;
      var n = mw * mh, seen = new Uint8Array(n), bg = new Uint8Array(n), stack = [];
      stack.push(0, mw - 1, (mh - 1) * mw, mh * mw - 1);      /* 四角种子 */
      var cleared = 0;
      while (stack.length) {
        var idx = stack.pop();
        if (seen[idx]) continue;
        seen[idx] = 1;
        var i4 = idx * 4, isBg = false;
        if (d[i4 + 3] < 40) { isBg = true; }                  /* 本来就透明 -> 视为背景 */
        else {
          var dr = d[i4] - tc[0], dg = d[i4 + 1] - tc[1], db = d[i4 + 2] - tc[2];
          if (dr * dr + dg * dg + db * db <= lim2) isBg = true;
        }
        if (!isBg) continue;                                  /* 非背景 -> 不标记、不蔓延 */
        bg[idx] = 1; cleared++;
        var x = idx % mw, y = (idx - x) / mw;
        if (x > 0) stack.push(idx - 1);
        if (x < mw - 1) stack.push(idx + 1);
        if (y > 0) stack.push(idx - mw);
        if (y < mh - 1) stack.push(idx + mw);
      }
      if (!cleared) return null;                              /* 一个像素都没清 -> 交给兜底 */
      var mc = document.createElement('canvas'); mc.width = mw; mc.height = mh;
      var mg = mc.getContext('2d');
      var mid = mg.createImageData(mw, mh), md = mid.data;
      for (var p = 0; p < n; p++) {
        var p4 = p * 4;
        md[p4] = 255; md[p4 + 1] = 255; md[p4 + 2] = 255;
        md[p4 + 3] = bg[p] ? 0 : 255;
      }
      mg.putImageData(mid, 0, 0);
      return mc;
    } catch (e) { return null; }                              /* 跨域/异常 -> 退回 RemoveColor */
  }

  /* ---------- 自动取底色：四角像素众数（白底/纯色底都能认出）；跨域失败返回 null ---------- */
  function guessKey(el) {
    try {
      var w = el.naturalWidth || el.width, h = el.naturalHeight || el.height;
      if (!w || !h) return null;
      var S = Math.max(4, Math.min(24, Math.floor(Math.min(w, h) / 8)));
      var c = document.createElement('canvas'); c.width = S; c.height = S;
      var g = c.getContext('2d');
      var pts = [[0, 0], [w - S, 0], [0, h - S], [w - S, h - S]], counts = {}, k;
      for (var p = 0; p < pts.length; p++) {
        g.clearRect(0, 0, S, S);
        g.drawImage(el, pts[p][0], pts[p][1], S, S, 0, 0, S, S);
        var d = g.getImageData(0, 0, S, S).data;
        for (var i = 0; i < d.length; i += 4) {
          if (d[i + 3] < 40) continue;                      /* 透明像素不算 */
          k = ((d[i] >> 4) << 8) | ((d[i + 1] >> 4) << 4) | (d[i + 2] >> 4);
          counts[k] = (counts[k] || 0) + 1;
        }
      }
      var best = null, bn = -1;
      for (k in counts) { if (counts[k] > bn) { bn = counts[k]; best = parseInt(k, 10); } }
      if (best === null) return null;
      var hex = function (x) { var s = (x * 17).toString(16); return s.length < 2 ? '0' + s : s; };
      return '#' + hex((best >> 8) & 15) + hex((best >> 4) & 15) + hex(best & 15);
    } catch (e) { return null; }
  }

  /* ---------- 写入：按固定序重建 filters 数组 → applyFilters（无参！）→ 置脏 ---------- */
  function commit(doSave) {
    if (!cur) return;
    var img = cur.img, F = fabric.Image.filters, arr = [];
    if (ST.rm) {
      var dist = ST.rm.distance;
      if (dist > 0) {
        var mk = pixelSafe(img) ? floodMask(oEl(img), ST.rm.color || '#ffffff', dist) : null;
        if (mk) {
          arr.push(new F.BlendImage({ image: new fabric.Image(mk), mode: 'mask', alpha: 1 }));
          img.__pfmBgCut = { color: ST.rm.color || '#ffffff', tol: dist };
        } else {
          /* 兜底：泛洪不可用（跨域 / 未识别到底色）-> 退回按色删除 */
          arr.push(new F.RemoveColor({ color: ST.rm.color || '#ffffff', distance: dist }));
          img.__pfmBgCut = null;
        }
      }
    } else {
      img.__pfmBgCut = null;
    }
    /* 着色：**去底之后、饱和度/调整之前** —— 顺序反了 tint 会把调整结果压平 */
    if (ST.cz && ST.cz.amount > 0) {
      arr.push(new F.BlendColor({ color: ST.cz.color || CZ_DEF.color,
        mode: ST.cz.mode || 'tint',
        alpha: Math.max(0, Math.min(1, ST.cz.amount / 100)) }));
    }
    /* 两趟：饱和度 ColorMatrix 先入数组（canonical 序与 UI 行序解耦） */
    ADJ.forEach(function (a) {
      if (a.cm !== 'sat' || ST[a.k] === a.def) return;
      arr.push(new F.ColorMatrix({ matrix: satMatrix(1 + ST[a.k] / 100) }));
    });
    ADJ.forEach(function (a) {
      if (a.cm === 'sat' || ST[a.k] === a.def) return;
      var o = {}; o[a.param] = a.toF(ST[a.k]);
      arr.push(new F[a.ctor](o));
    });
    TOGGLES.forEach(function (t) { if (ST[t[0]]) arr.push(new F[CTOR[t[0]]]()); });

    img.filters = arr;
    applyCrop(img);   /* 先裁再跑滤镜：_element 由 crop 区域重建，滤镜作用于裁后像素 */
    try { img.applyFilters(); } catch (e) { /* 见文件头坑① —— 参数传错才会到这里 */ }
    img.dirty = true;
    if (cur.parent) {
      cur.parent.dirty = true;
      /* 裁切会改子对象的 left/width -> 组包围盒要重算，否则选择框偏大 */
      try { if (cur.parent._calcBounds) { cur.parent._calcBounds(); cur.parent.setCoords(); } } catch (e) { }
    }
    render();
    if (doSave) save();
  }

  /* ---------- 面板 DOM（程序化生成，保持 design-board 的 diff 极小） ---------- */
  function build() {
    if (built) return;
    var pop = q('pfmImgPop'); if (!pop) return;
    built = true;
    var h = '';
    h += '<div class="pfm-imgpop-hd"><span class="pfm-imgpop-title">Image effects</span>'
      + '<button class="pfm-imgpop-x" id="pfmImgPopClose" type="button" aria-label="Close">\u2715</button></div>';
    h += '<div class="pfm-imgpop-body">';
    /* 2026-09-19: Opacity 从底栏搬进来（底栏已删）—— 作用于当前选中对象。 */
    h += '<div class="pfm-imgpop-grp">Opacity</div>';
    h += '<div class="pfm-imgpop-row"><input type="range" class="pfm-imgpop-range" id="pfmImgOpacity" min="0" max="100" step="1" value="100" aria-label="Opacity">'
      + '<span class="pfm-imgpop-val" id="pfmImgOpacityVal">100</span></div>';
    h += '<div class="pfm-imgpop-grp">Remove background</div>';
    h += '<div class="pfm-imgpop-row"><input type="color" class="pfm-imgpop-color" id="pfmImgKeyColor" value="#ffffff" aria-label="Background color">'
      + '<input type="range" class="pfm-imgpop-range" id="pfmImgKeyTol" min="2" max="60" step="1" value="12" aria-label="Tolerance">'
      + '<span class="pfm-imgpop-val" id="pfmImgKeyTolVal">12</span></div>';
    h += '<div class="pfm-imgpop-row"><button class="pfm-imgpop-btn" id="pfmImgKeyApply" type="button">Remove colour</button>'
      + '<button class="pfm-imgpop-btn ghost" id="pfmImgKeyClear" type="button">Reset</button></div>';
    h += '<div class="pfm-imgpop-hint" id="pfmImgKeyHint">Auto colour from the image corners</div>';
    h += '<div class="pfm-imgpop-grp">Crop</div>';
    CROP.forEach(function (c) {
      h += '<div class="pfm-imgpop-row"><span class="pfm-imgpop-lbl">' + c[1] + '</span>'
        + '<input type="range" class="pfm-imgpop-range" id="pfmImgCrop_' + c[0] + '" min="0" max="49" step="1" value="0" aria-label="Crop ' + c[1] + '">'
        + '<span class="pfm-imgpop-val" id="pfmImgCropVal_' + c[0] + '">0%</span></div>';
    });
    h += '<div class="pfm-imgpop-row"><button class="pfm-imgpop-btn ghost" id="pfmImgCropReset" type="button">Reset crop</button></div>';
    h += '<div class="pfm-imgpop-grp">Adjust</div>';
    ADJ.forEach(function (a) {
      h += '<div class="pfm-imgpop-row"><span class="pfm-imgpop-lbl">' + a.lbl + '</span>'
        + '<input type="range" class="pfm-imgpop-range" id="pfmImgAdj_' + a.k + '" min="' + a.min + '" max="' + a.max + '" step="' + a.step + '" value="' + a.def + '" aria-label="' + a.lbl + '">'
        + '<span class="pfm-imgpop-val" id="pfmImgAdjVal_' + a.k + '">' + a.def + '</span></div>';
    });
    h += '<div class="pfm-imgpop-row"><button class="pfm-imgpop-btn ghost" id="pfmImgAdjReset" type="button">Reset adjust</button></div>';
    h += '<div class="pfm-imgpop-grp">Colorize</div>';
    h += '<div class="pfm-imgpop-row"><input type="color" class="pfm-imgpop-color" id="pfmImgCzColor" value="#7C3AED" aria-label="Colorize colour">'
      + '<input type="range" class="pfm-imgpop-range" id="pfmImgCzAmt" min="0" max="100" step="1" value="100" aria-label="Colorize strength">'
      + '<span class="pfm-imgpop-val" id="pfmImgCzAmtVal">100</span></div>';
    h += '<div class="pfm-imgpop-chips" id="pfmImgCzModes">';
    CZ_MODES.forEach(function (m, i) { h += '<button class="pfm-imgpop-chip' + (i === 0 ? ' sel' : '') + '" data-cz="' + m[0] + '" type="button">' + m[1] + '</button>'; });
    h += '</div>';
    h += '<div class="pfm-imgpop-row"><button class="pfm-imgpop-btn ghost" id="pfmImgCzReset" type="button">Reset colour</button></div>';
    h += '<div class="pfm-imgpop-grp">Presets</div><div class="pfm-imgpop-chips" id="pfmImgPresets">';
    TOGGLES.forEach(function (t) { h += '<button class="pfm-imgpop-chip" data-k="' + t[0] + '" type="button">' + t[1] + '</button>'; });
    h += '</div>';
    h += '<div class="pfm-imgpop-grp">Blend</div><div class="pfm-imgpop-chips" id="pfmImgBlend">';
    BLENDS.forEach(function (b, i) { h += '<button class="pfm-imgpop-chip' + (i === 0 ? ' sel' : '') + '" data-b="' + b[0] + '" type="button">' + b[1] + '</button>'; });
    h += '</div></div>';
    pop.innerHTML = h;
    wire();
  }

  var rafId = null;
  function liveApply() {
    if (rafId) return;
    rafId = requestAnimationFrame(function () { rafId = null; commit(false); });
  }

  function wire() {
    var pop = q('pfmImgPop'); if (!pop) return;
    var x = q('pfmImgPopClose'); if (x) x.addEventListener('click', function () { close(); });
    /* 2026-09-19: Opacity 滑杆（原底栏那根搬来）—— input 实时改对象不透明度；change 落快照。 */
    var opb = q('pfmImgOpacity');
    if (opb) opb.addEventListener('input', function () {
      var c2 = cv(), o2 = null; try { o2 = c2 && c2.getActiveObject ? c2.getActiveObject() : null; } catch (e) { }
      var v = Math.max(0, Math.min(100, parseInt(opb.value, 10) || 0));
      var vv = q('pfmImgOpacityVal'); if (vv) vv.textContent = v;
      if (!o2) return;
      try { o2.set({ opacity: v / 100 }); } catch (e) { }
      if (c2 && c2.renderAll) c2.renderAll();
    });
    if (opb) opb.addEventListener('change', function () { try { if (window.__pfmSaveState) window.__pfmSaveState(); } catch (e) { } });

    /* 去底 */
    var tol = q('pfmImgKeyTol');
    if (tol) tol.addEventListener('input', function () {
      var v = q('pfmImgKeyTolVal'); if (v) v.textContent = tol.value;
    });
    var kApply = q('pfmImgKeyApply');
    if (kApply) kApply.addEventListener('click', applyKey);
    var kClear = q('pfmImgKeyClear');
    if (kClear) kClear.addEventListener('click', function () {
      if (!ST) return; ST.rm = null;
      commit(true); toast('Background colour restored');
    });

    /* 裁切滑杆 */
    CROP.forEach(function (c) {
      var r = q('pfmImgCrop_' + c[0]), v = q('pfmImgCropVal_' + c[0]);
      if (!r) return;
      var k = 'crop' + c[0].toUpperCase();
      r.addEventListener('input', function () {
        if (!ST) return;
        ST[k] = parseInt(r.value, 10) || 0;
        clampCrop(ST);
        syncCropUI();
        liveApply();                     /* 拖动中实时预览（rAF 节流） */
      });
      r.addEventListener('change', function () { commit(true); });   /* 松手才入撤销栈 */
    });
    var cReset = q('pfmImgCropReset');
    if (cReset) cReset.addEventListener('click', function () {
      if (!ST) return;
      ST.cropL = ST.cropR = ST.cropT = ST.cropB = 0;
      syncCropUI(); commit(true); toast('Crop reset');
    });

    /* 调整滑杆 */
    ADJ.forEach(function (a) {
      var r = q('pfmImgAdj_' + a.k), v = q('pfmImgAdjVal_' + a.k);
      if (!r) return;
      r.addEventListener('input', function () {
        if (!ST) return;
        ST[a.k] = parseInt(r.value, 10) || 0;
        if (v) v.textContent = r.value;
        liveApply();                       /* 拖动中实时预览（rAF 节流） */
      });
      r.addEventListener('change', function () { commit(true); });   /* 松手才入撤销栈 */
    });
    var reset = q('pfmImgAdjReset');
    if (reset) reset.addEventListener('click', function () {
      if (!ST) return;
      ADJ.forEach(function (a) { ST[a.k] = a.def; });
      TOGGLES.forEach(function (t) { ST[t[0]] = false; });
      syncUI(); commit(true); toast('Adjust and presets reset');
    });

    /* 着色：颜色/强度/模式。强度 0 = 关闭（commit 里直接不入链） */
    function czEnsure() {
      if (!ST.cz) ST.cz = { color: CZ_DEF.color, amount: CZ_DEF.amount, mode: CZ_DEF.mode };
      return ST.cz;
    }
    var czc = q('pfmImgCzColor');
    if (czc) {
      czc.addEventListener('input', function () {
        if (!ST) return;
        var cz = czEnsure(); cz.color = czc.value;
        if (!(cz.amount > 0)) cz.amount = CZ_DEF.amount;   /* 从 0 拉颜色 = 启用 */
        syncCzUI(); liveApply();
      });
      czc.addEventListener('change', function () { commit(true); });
    }
    var cza = q('pfmImgCzAmt');
    if (cza) {
      cza.addEventListener('input', function () {
        if (!ST) return;
        var cz = czEnsure(); cz.amount = parseInt(cza.value, 10) || 0;
        syncCzUI(); liveApply();
      });
      cza.addEventListener('change', function () { commit(true); });
    }
    var czm = q('pfmImgCzModes');
    if (czm) czm.addEventListener('click', function (e) {
      var b2 = e.target.closest('.pfm-imgpop-chip'); if (!b2 || !ST) return;
      var cz = czEnsure(); cz.mode = b2.dataset.cz || 'tint';
      if (!(cz.amount > 0)) cz.amount = CZ_DEF.amount;
      syncCzUI(); commit(true);
    });
    var czr = q('pfmImgCzReset');
    if (czr) czr.addEventListener('click', function () {
      if (!ST) return; ST.cz = null; syncCzUI(); commit(true); toast('Colour reset');
    });

    /* 预设 */
    var pre = q('pfmImgPresets');
    if (pre) pre.addEventListener('click', function (e) {
      var b = e.target.closest('.pfm-imgpop-chip'); if (!b || !ST) return;
      var k = b.dataset.k; ST[k] = !ST[k];
      b.classList.toggle('sel', !!ST[k]);
      commit(true);
    });

    /* 混合模式 */
    var bl = q('pfmImgBlend');
    if (bl) bl.addEventListener('click', function (e) {
      var b = e.target.closest('.pfm-imgpop-chip'); if (!b || !cur) return;
      var mode = b.dataset.b || 'source-over';
      try { cur.img.globalCompositeOperation = mode; } catch (err) { return; }
      cur.img.dirty = true;
      if (cur.parent) cur.parent.dirty = true;
      render(); save();
      [].forEach.call(bl.children, function (c) { c.classList.toggle('sel', c === b); });
      toast(mode === 'source-over' ? 'Blend: Normal' : 'Blend applied (kept on export)');
    });
  }

  function applyKey() {
    if (!cur || !ST) return;
    var cc = q('pfmImgKeyColor'), tol = q('pfmImgKeyTol');
    if (!pixelSafe(cur.img)) { toast('This image is cross-origin — pixel effects unavailable'); return; }
    var color = (cc && cc.value) || '#ffffff';
    var dist = Math.max(0.02, Math.min(0.6, (parseInt(tol && tol.value, 10) || 12) / 100));
    ST.rm = { color: color, distance: dist };
    var nBefore = (cur.img.filters || []).length;
    commit(true);
    var nAfter = (cur.img.filters || []).length;
    toast(nAfter > nBefore ? 'Background removed (not exported)' : 'Background settings updated');
  }

  /* 2026-09-16: 着色行同步（ST.cz 为 null = 未启用 → 强度显示 0、模式不高亮） */
  function syncCzUI() {
    var c = q('pfmImgCzColor'), a2 = q('pfmImgCzAmt'), v = q('pfmImgCzAmtVal'), m = q('pfmImgCzModes');
    var cz = ST && ST.cz;
    if (c && cz && cz.color) c.value = cz.color;
    if (a2) a2.value = cz ? cz.amount : 0;
    if (v) v.textContent = a2 ? a2.value : '';
    if (m) {
      var mode = cz ? (cz.mode || 'tint') : '';
      [].forEach.call(m.children, function (b2) { b2.classList.toggle('sel', b2.dataset.cz === mode); });
    }
  }

  function syncUI() {
    var cc = q('pfmImgKeyColor'), tol = q('pfmImgKeyTol'), tv = q('pfmImgKeyTolVal');
    if (ST && ST.rm) {
      if (cc) cc.value = ST.rm.color || '#ffffff';
      if (tol) tol.value = Math.round((ST.rm.distance || 0.12) * 100);
      if (tv) tv.textContent = tol ? tol.value : '';
    }
    ADJ.forEach(function (a) {
      var r = q('pfmImgAdj_' + a.k), v = q('pfmImgAdjVal_' + a.k);
      if (r) r.value = ST ? ST[a.k] : a.def;
      if (v) v.textContent = r ? r.value : '';
    });
    syncCropUI();
    syncCzUI();
    var pre = q('pfmImgPresets');
    if (pre) [].forEach.call(pre.children, function (c) { c.classList.toggle('sel', !!(ST && ST[c.dataset.k])); });
    var bl = q('pfmImgBlend');
    if (bl) {
      var mode = (cur && cur.img.globalCompositeOperation) || 'source-over';
      [].forEach.call(bl.children, function (c) { c.classList.toggle('sel', c.dataset.b === mode); });
    }
    var hint = q('pfmImgKeyHint');
    if (hint) {
      if (!cur) { hint.textContent = ''; return; }
      var ps = pixelSafe(cur.img);
      hint.textContent = ps
        ? 'Removes the background touching the edges (colour auto-detected from corners)'
        : 'This image is cross-origin — pixel effects are unavailable';
    }
  }

  function open() {
    if (!cur) return;
    /* 2026-10-13（甲 · 用户报「点 Effects 素材库还在，挡住很多功能」）：
       选中对象的「Image effects」面板出现时，把素材面板让出去 —— 否则 #panel-upload 与效果面板
       在右栏同时占位，效果面板被顶到列表最下方（素材库满铺时甚至到 4000px 之外）。
       🔴 桌面端原本**不**隐藏素材面板（hd-objtabs 的 sync() 只在移动端 hidePanels）
          ⇒ 这一环缺失只在桌面暴露。关闭时由 close() 恢复（记在 window.__pfmFxPrevPanel）。 */
    try {
      window.__pfmFxPrevPanel = null;
      var _ps = document.querySelectorAll('.pfm-panel');
      for (var _pi = 0; _pi < _ps.length; _pi++) {
        if (_ps[_pi].style.display === 'block') window.__pfmFxPrevPanel = _ps[_pi].id;
        _ps[_pi].style.display = 'none';
      }
    } catch (e) { }
    /* 2026-09-19: 展开路径 ⇒ 清掉对象组打来的「格标记」，避免残留到下一次收起时误判。 */
    window.__pfmFxByCell = false;
    build();
    if (!pixelSafe(cur.img)) { toast('This image is cross-origin — pixel effects unavailable (blend still works)'); }
    ST = snap(cur.img);
    try { syncOpacity(); } catch (e) { }
    var cc = q('pfmImgKeyColor'), tol = q('pfmImgKeyTol'), tv = q('pfmImgKeyTolVal');
    if (!ST.rm) {
      var g = guessKey(cur.img._originalElement || cur.img._element);
      if (cc) cc.value = g || '#ffffff';
      if (tol) tol.value = 12;
      if (tv) tv.textContent = '12';
    } else { syncUI(); }
    var pop = q('pfmImgPop');
    if (pop) { pop.classList.add('on'); openFlag = true; }
    syncUI();
    var btn = q('pfmImgBtnFx'); if (btn) btn.classList.add('on');
  }

  function close() {
    var pop = q('pfmImgPop');
    if (pop) pop.classList.remove('on');
    openFlag = false;
    /* 2026-09-19: byCell = 本次收起来自「点对象组 Effects 格」（section 侧在 fx.click() 前写入）。
       它是「要不要动抽屉」的唯一判据：点别的属性格时 section 也会调本函数，那种情况不能动抽屉。 */
    var byCell = !!window.__pfmFxByCell;
    window.__pfmFxByCell = false;
    var btn = q('pfmImgBtnFx'); if (btn) btn.classList.remove('on');
    /* 2026-09-20: 收起效果面板时**保持 Effects 高亮、并把抽屉一起收起** ——
       用户定义的基本逻辑是「点开哪个格 ⇒ 落位哪个格 + 哪个格高亮」，
       所以这里**不做任何"替用户重选格子"的动作**。
       （旧实现：清锁 + 清记忆 + __pfmObjSync() ⇒ sync 重选默认格，而它跳过 bg/effects/layers
         ⇒ 恒为 Size ⇒ 用户报「Effects 展开、收起，会变成 size 亮起」。）
       pop 一关，抽屉里就没有可"落位"的属性区块了，抽屉留着只会是空白 ⇒ 必须一起收起。
       ⚠️ 必须**延后一拍**：点 Effects 格时 section 的顺序是「hidePanels() → 点按钮(触发本函数)
          → 最后才写动作锁 + setTab(null) + 无条件打开抽屉」，立即处理会被它覆盖。
       ⚠️ 只有 byCell 才动抽屉 —— 点别的属性格时 section 也会调本函数，而它随后会自己打开抽屉
          并显示对应区块，这里若收抽屉会把用户刚点的格关掉。
       ⚠️ 不清那两个「最后点的格 / 对象」记忆：让后续 sync 走「同一对象重复同步 ⇒ 保持现状」
          分支，高亮与格选择都不会被重置回默认格。 */
    setTimeout(function () {
      try {
        var act = window.__pfmObjAct;
        if (byCell && !openFlag && act && act.btn && act.btn.getAttribute('data-objtab') === 'effects') {
          window.__pfmObjAct = null;
          try { if (window.__pfmDrawerClose) window.__pfmDrawerClose(); } catch (e) { }
        } else if (!byCell && window.__pfmFxPrevPanel) {
          /* 2026-10-13（甲）：桌面上点 Effects 时素材面板被收起（见 open()）⇒ 这里把它放回来，
             否则用户关掉效果面板后右栏只剩常驻条。移动端（byCell）交给 hd-objtabs 的 sync()，勿重复。 */
          var _pp = document.getElementById(window.__pfmFxPrevPanel);
          if (_pp) _pp.style.display = 'block';
          var _pk = String(window.__pfmFxPrevPanel).replace('panel-', '');
          var _tb = document.querySelector('.pfm-stab[data-panel="' + _pk + '"]');
          document.querySelectorAll('.pfm-stab[data-panel]').forEach(function (b) { b.classList.remove('sel'); });
          if (_tb) _tb.classList.add('sel');
          window.__pfmFxPrevPanel = null;
        }
      } catch (e) { }
    }, 0);
  }

  /* ---------- 选中态跟随（2026-09-13 改）----------
     入口行 #pfmImgRow 现在常显（不再随选中切换显隐）—— 无可用图片时把两个按钮置灰禁用。
     好处：Actions 卡片高度恒定，选中/取消不会让画布上下跳动。 */
  function onSel() {
    var t = resolveTarget();
    cur = t;
    /* ⚠️ 这里**不能**清说明条（2026-09-19 实测）：onSel 还挂在 object:removed 上，
       而画布重绘（resizeCanvasToPrintArea → drawGrid）会移除/重加网格对象 ⇒ 触发它
       ⇒ 说明条会在 240ms 后被静默清掉，看起来像「自己消失了」。
       清理由下面三个 selection:* 事件单独负责。 */
    var b1 = q('pfmImgBtnBg'), b2 = q('pfmImgBtnFx');
    if (b1) b1.disabled = !t;
    if (b2) b2.disabled = !t;
    /* 🔴 2026-10-12 用户裁决「不要自动收起」：原实现「没有选中对象 ⇒ 立即关闭面板」。
       但画布重建（切面 / 加载完成 / 草稿恢复 / undo 重放）会清空选中
       ⇒ 刚打开的 Effects 面板会「过一会儿自己收起」（无任何定时器，纯被这条规则连坐）。
       现改为：**不再自动收起**，只把下方两个按钮置灰（上两行已设 disabled）；
       关闭仅由用户主动操作：再点 Effects / 点面板的 ✕ / 切触摸布局。 */
    if (!t) { return; }
    if (openFlag) { ST = snap(t.img); syncUI(); }
  }

  window.__hdImage = {
    init: function (deps) {
      if (inited) return;
      inited = true;
      D = deps || {};
      build();
      var c = cv();
      if (c && c.on) {
        /* 只有「真的换了选中」才清说明条；object:removed 只是画布重绘，不许清。 */
        c.on('selection:created', function () { clearHint(); onSel(); });
        c.on('selection:updated', function () { clearHint(); onSel(); });
        c.on('selection:cleared', function () { clearHint(); onSel(); });
        c.on('object:removed', onSel);
      }
      /* 初始同步一次：板打开时可能没有选中对象（onSel 不会被 selection 事件触发），
         而按钮的 disabled 初值就在 board 的 HTML 里 —— 这里确保与真实选中态一致。 */
      try { onSel(); } catch (e) {}
      try { watchHint(); } catch (e) { }
      var btnBg = q('pfmImgBtnBg');
      if (btnBg) btnBg.addEventListener('click', function () {
        var t = resolveTarget(); cur = t;
        if (!t) return;
        if (!pixelSafe(t.img)) { hint("This image can't be edited pixel by pixel — try re-uploading it."); return; }
        build();
        var g = guessKey(t.img._originalElement || t.img._element);
        ST = snap(t.img);
        if (!g && !ST.rm) { hint('No solid background detected — open Effects to pick the background colour.'); return; }
        var cc = q('pfmImgKeyColor'), tol = q('pfmImgKeyTol');
        if (cc) cc.value = g || '#ffffff';
        var dist = Math.max(0.02, Math.min(0.6, (parseInt(tol && tol.value, 10) || 12) / 100));
        ST.rm = { color: g || '#ffffff', distance: dist };
        commit(true);
        clearHint();   /* 抠底成功 ⇒ 旧说明没意义（2026-09-19） */
        toast('Background removed: ' + (g || '#ffffff'));
      });
      var btnFx = q('pfmImgBtnFx');
      if (btnFx) btnFx.addEventListener('click', function () {
        if (openFlag) { close(); return; }
        cur = resolveTarget();
        if (!cur) return;
        open();
      });
    },
    /* 2026-09-16: 供吸管（assets/hd-pick.js）把取到的色应用到当前图片。
       会顺带打开 Effects 面板 —— 让用户看得见颜色落在哪，而不是「悄悄生效」。 */
    colorize: function (hex) {
      if (!/^#[0-9a-f]{6}$/i.test(hex || '')) return false;
      cur = resolveTarget();
      if (!cur) return false;
      if (!pixelSafe(cur.img)) { toast('This image is cross-origin — colour cannot be changed'); return false; }
      open();                       /* open() 内部会 ST = snap(img) */
      if (!ST) return false;
      if (!ST.cz) ST.cz = { color: hex, amount: CZ_DEF.amount, mode: CZ_DEF.mode };
      else { ST.cz.color = hex; if (!(ST.cz.amount > 0)) ST.cz.amount = CZ_DEF.amount; }
      syncCzUI();
      commit(true);
      return true;
    },
    isOpen: function () { return openFlag; },
    close: close
  };
})();
